// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2JPMX","errorLogs":"styles_errorLogs__11W8o"};